export const DOCUMENTS = {
  PRIVACY_POLICY: 0,
  TERMS_OF_USE: 1,
};
